<template>
  <div class="contents users" v-loading="loading">
    <div class="title flexB">
      <h2>회원 관리</h2>
    </div>
    <div class="filterArea">
      <div class="filterWrap flex">
        <el-select v-model="inputMode">
          <el-option label="이메일" value="email"> </el-option>
          <el-option label="닉네임" value="nickname"> </el-option>
        </el-select>

        <input type="text" v-model="searchWord" @keyup.enter="search" />
        <button class="basic" @click="search">검색</button>
      </div>
      <div class="subscriptionFilter">
        <span>구독여부</span>
        <el-radio-group
          v-model="subscriptionStatus"
          @change="handleListFilterChange"
        >
          <el-radio label="all">전체</el-radio>
          <el-radio label="active">구독중</el-radio>
          <el-radio label="cancelled">해지 예정</el-radio>
          <el-radio label="inactive">미구독</el-radio>
        </el-radio-group>
      </div>
      <div class="subscriptionFilter">
        <span>탈퇴회원</span>
        <el-checkbox v-model="hideWithdrawn" @change="handleListFilterChange">
          숨기기
        </el-checkbox>
      </div>
    </div>

    <div class="box one">
      <table>
        <colgroup>
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 22%" />
          <col style="width: 18%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 20%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>구분</th>
          <th>이메일</th>
          <th>닉네임</th>
          <th>구독여부</th>
          <th>가입경로</th>
          <th>레벨</th>
          <th>가입일</th>
        </tr>
        <tr v-for="(data, i) in userList" :key="i">
          <td>
            {{ total - ((currentPage - 1) * 10 + i) }}
          </td>
          <td>
            {{ data.isAdmin ? "관리자" : "일반" }}
          </td>
          <td>
            <router-link to @click.native="handleDetail(data._id)">
              {{ data.dropedAt != null ? "탈퇴회원" : data.email }}
            </router-link>
          </td>
          <td>{{ data.nickname }}</td>
          <td :class="{ primary: data.isSubscriptionActive }">
            {{ getSubscriptionLabel(data) }}
          </td>
          <td>{{ getAuthProviderLabel(data.authProvider) }}</td>
          <!-- <td>{{ getPurposeLabel(data.purpose) }}</td> -->
          <td>{{ data.level }}</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="userList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { fetchUserList } from "@/api/admin";
import { format } from "@/mixins/format";
export default {
  mixins: [format],
  name: "users",
  data() {
    return {
      moment: moment,
      inputMode: "",
      searchWord: "",
      userList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      loading: false,
      subscriptionStatus: "all",
      hideWithdrawn: true,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "1");
  },
  mounted() {
    // this.loading = true;
    this.getUserList();
  },
  methods: {
    handleDetail(id) {
      this.$router.push({ name: "userDetail", query: { id: id } });
    },
    getSubscriptionLabel(user) {
      if (user?.subscriptionLabel) {
        return user.subscriptionLabel;
      }
      return user?.isMember ? "구독중" : "미구독";
    },
    isWithdrawnUser(user) {
      return user.authProvider === "withdrawn" || user.dropedAt != null;
    },
    matchesSubscriptionFilter(user, filter) {
      if (!filter || filter === "all") {
        return true;
      }
      if (filter === "inactive") {
        return ["expired", "none"].includes(user.subscriptionStatus);
      }
      return user.subscriptionStatus === filter;
    },
    applyListFilters(users = []) {
      let filtered = users;

      if (this.hideWithdrawn) {
        filtered = filtered.filter((user) => !this.isWithdrawnUser(user));
      }

      const subscriptionFilter =
        this.subscriptionStatus && this.subscriptionStatus !== "all"
          ? this.subscriptionStatus
          : "";
      if (subscriptionFilter) {
        filtered = filtered.filter((user) =>
          this.matchesSubscriptionFilter(user, subscriptionFilter)
        );
      }

      return filtered;
    },
    needsClientSideFilter() {
      return (
        this.hideWithdrawn ||
        (this.subscriptionStatus && this.subscriptionStatus !== "all")
      );
    },
    async fetchAllUsers(params) {
      const countRes = await fetchUserList({
        ...params,
        page: 1,
        limit: 1,
      });
      const countPayload = countRes.data || {};

      if (countPayload.status !== 200) {
        throw new Error(
          countPayload.message || "회원 목록을 불러오지 못했습니다."
        );
      }

      const total = Number(countPayload.total || 0);
      if (total === 0) {
        return [];
      }

      const listRes = await fetchUserList({
        ...params,
        page: 1,
        limit: total,
      });
      const listPayload = listRes.data || {};

      if (listPayload.status !== 200) {
        throw new Error(
          listPayload.message || "회원 목록을 불러오지 못했습니다."
        );
      }

      return Array.isArray(listPayload.users) ? listPayload.users : [];
    },
    getAuthProviderLabel(authProvider) {
      const authProviderMap = {
        apple: "애플",
        google: "구글",
        email: "이메일",
        withdrawn: "-",
      };

      return authProviderMap[authProvider] || authProvider || "-";
    },
    getPurposeLabel(purpose) {
      const purposeMap = {
        travel: "여행 또는 유학",
        conversation: "외국인과 대화",
        self_improvement: "자기계발",
        employment: "취업 준비",
        kpop: "한국 문화",
      };

      return purposeMap[purpose] || purpose || "-";
    },

    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.subscriptionStatus = "all";
      this.hideWithdrawn = true;
      this.userList = [];
      this.total = 0;
      this.currentPage = 1;
      this.getUserList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        return alert("검색 조건을 선택해 주세요.");
      }
      this.currentPage = 1;
      this.getUserList();
    },
    handleListFilterChange() {
      this.currentPage = 1;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$router.push({ name: "users", query: { page: val } });
      this.getUserList();
    },
    async getUserList() {
      this.loading = true;
      const pageSize = 10;
      const baseParams = {
        inputMode: this.inputMode,
        searchWord: this.searchWord,
      };
      try {
        let payload;

        if (this.needsClientSideFilter()) {
          const allUsers = await this.fetchAllUsers(baseParams);
          const filteredUsers = this.applyListFilters(allUsers);
          const start = (this.currentPage - 1) * pageSize;

          payload = {
            status: 200,
            users: filteredUsers.slice(start, start + pageSize),
            total: filteredUsers.length,
            page: this.currentPage,
          };
        } else {
          const res = await fetchUserList({
            ...baseParams,
            page: this.currentPage,
          });
          payload = res.data || {};
        }

        if (payload.status == 200) {
          this.userList = Array.isArray(payload.users) ? payload.users : [];
          this.total = payload.total || 0;
          this.isNodata = this.total == 0;
          this.currentPage = payload.page || this.currentPage;
        } else if (payload.status == 409) {
          this.$router.push("/");
          alert(payload.message);
        } else {
          alert(payload.message);
        }
      } catch (err) {
        alert(err.message || "회원 목록을 불러오지 못했습니다.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filterArea {
  margin: 90px 30px 30px;
  width: calc(100% - 60px);
}

.subscriptionFilter {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  padding: 12px 20px;
  background: #fff;
  border-radius: 4px;

  > span {
    flex-shrink: 0;
    font-weight: 600;
    color: #1e1e1e;
  }
}

.filterArea .filterWrap {
  margin: 0;
  width: 100%;
}
</style>
